import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)<{ logoSize: number; isSquare?: boolean }>`
  .error-wrapper {
    border-radius: ${theme.attributes.borderRadius.circle};
    position: relative;
    cursor: pointer;
    border: 1px solid ${theme.baseColors.info[50]};
    box-sizing: content-box;
    /* Removes the unnecessary margin in configuration settings data source when it has error */
    //margin-left: ${({ logoSize }) => (logoSize === 40 ? `${theme.spacing.xsm}px` : '')};

    ${({ isSquare }) => isSquare && `border-radius: ${theme.attributes.borderRadius.secondary}`};

    img {
      border-radius: ${theme.attributes.borderRadius.circle};
    }

    svg {
      position: absolute;
      bottom: -2px;
      left: 5px;

      &.error-content {
        bottom: 0;
        left: 7px;
      }
    }

    ${({ logoSize }) =>
      logoSize === 23 &&
      `
        svg {
          position: absolute;
          bottom: -2px;
          left: ${theme.spacing.sm}px;
    
          &.error-content {
            bottom: 0;
            left: ${theme.spacing.md}px;
          }
        }
      `};

    ${({ isSquare }) =>
      isSquare &&
      `
      img {
        border-radius: ${theme.attributes.borderRadius.secondary} !important;
      }
      
        svg {
          bottom: -2px;
          right: -2px !important;
          left: unset !important;
    
          &.error-content {
            bottom: 0;
            right: -0px !important;
            left: unset !important;
          }
        }
      `};

    &.no-base-icon {
      width: 14px;
      height: 14px;
      border: 0;

      svg {
        top: 0;
        left: 0;
        right: unset;

        &.error-content {
          bottom: unset;
          top: 2px;
          left: 2px;
          right: unset;
        }
      }
    }

    &.trends-chart-error {
      svg {
        top: 7px;
        left: 7px;

        &.error-content {
          bottom: unset;
          top: 9px;
          left: 9px;
        }
      }
    }
  }
`
